import { useMutation, useQuery } from '@tanstack/react-query';

import { getUtmDictionary, updateBanners } from '../../../../api';
import { Banner } from '../../../../types/banner';

export const useUtms = () => useQuery({ queryKey: ['getUtmDictionary'], queryFn: getUtmDictionary });

export const useUpdateBanner = () =>
  useMutation({ mutationKey: ['updateBanner'], mutationFn: (data: Partial<Banner>) => updateBanners(data) });
